import {Injectable} from '@angular/core';
import {BrowserXhr} from '@angular/http';
import {UploadService} from './upload.service';
import {UploadProgressService} from './upload-progress.service';

@Injectable()
export class BrowserXhrWithOnProgressSupport extends BrowserXhr {

    private xhrId = 0;

    constructor(private uploadProgressService: UploadProgressService) {
        super();
    }

    build(): any {
        let xhr = super.build();
        this.xhrId++;
        let id = this.xhrId;
        if ('upload' in xhr && 'onprogress' in xhr.upload) {
            let startTime = Date.now();
            xhr.upload.onprogress = (event) => {
                let timeElapsed = Date.now() - startTime;
                let uploadSpeed = event.loaded / (timeElapsed / 1000);
                let timeRemaining = Math.ceil(((event.total - event.loaded) / uploadSpeed));

                event.uploadTimeRemaining = timeRemaining;
                event.uploadSpeed = (uploadSpeed / 1024 / 1024).toFixed(2);
                event.percentCompleted = ((event.loaded / event.total) * 100).toFixed(0);
                this.uploadProgressService.nextProgressEvent(id, event);
            };
        }
        return <any>(xhr);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/upload/browser-xhr-with-on-progress-support.ts